import React from 'react';

import { Button, Heading, Modal, Text } from '@auspost/postmaster-react';

import ClockIcon from 'assets/clock-icon.svg';
import RedirectIcon from 'assets/redirect-icon.svg';
import RedirectModalImage from 'assets/redirect-modal-image.svg';
import WarningIcon from 'assets/warning-icon.svg';

import { trackInteraction } from '../../../../store/analytics/analytics.thunks';
import { useAppDispatch } from '../../../../store/store';
import { REDIRECT_MODAL_CANCEL_TEST_ID, REDIRECT_MODAL_CONTINUE_TEST_ID } from './RedirectModal.test-ids';

import styles from './RedirectModal.module.scss';

interface RedirectModalProp {
  handleClose: () => void;
  handleContinue: () => void;
  isOpen: boolean;
}
const RedirectModal: React.FC<RedirectModalProp> = ({ handleClose, handleContinue, isOpen }) => {
  const dispatch = useAppDispatch();
  return (
    <Modal
      isModalShowing={isOpen}
      onHide={handleClose}
      modalClassName={styles.redirectModal}
      ariaDialogLabel='redirect modal'
      noOverlayPadding
    >
      <Modal.Content className={styles.modalContent} onKeyDown={(e) => e.key === 'Escape' && handleClose()}>
        <RedirectModalImage className={styles.redirectModalImage} />
        <Heading level='h4' isBold>
          Redirect it – what you need to know
        </Heading>

        <section>
          <ClockIcon />
          <Text variant='body'>Redirecting a parcel will increase delivery time by 1 to 5 days</Text>
        </section>

        <section>
          <RedirectIcon />
          <Text variant='body'>Until it’s onboard for delivery, you can request a redirect</Text>
        </section>

        <section>
          <WarningIcon />
          <Text variant='body'>
            If we can’t redirect it, we’ll notify you in tracking and deliver it to the original delivery address
          </Text>
        </section>
      </Modal.Content>

      <Modal.Footer className={styles.modalFooter} alignment='center'>
        <div className={styles.divider}></div>
        <Button
          className={styles.modalBtn}
          variant='secondary'
          size='small'
          onClick={() => {
            dispatch(trackInteraction('redirect it – what you need to know: Cancel'));
            handleClose();
          }}
          data-testid={REDIRECT_MODAL_CANCEL_TEST_ID}
        >
          Cancel
        </Button>
        <Button
          className={styles.modalBtn}
          variant='primary'
          size='small'
          onClick={() => {
            dispatch(trackInteraction('redirect it – what you need to know: Continue'));
            handleContinue();
          }}
          data-testid={REDIRECT_MODAL_CONTINUE_TEST_ID}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RedirectModal;
